import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { dealTypesManager, type IDealType } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const DEAL_TYPE_MODULE = 'dealType';

const dataObjectModule = getDataObjectsModule<IDealType>(dealTypesManager, 3);
const searchModule = getSearchModule<IDealType>(dealTypesManager);

const dealTypeModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(DEAL_TYPE_MODULE, dealTypeModuleInstance);

export { DEAL_TYPE_MODULE };
